import styled, { css } from 'styled-components';

export const LastMovements = styled.div`
  display: inline-block;
  font-size: 16px;
  color: #444b62;
  font-family: Roboto;
  text-align: left;
  margin-top: 21px;
  margin-bottom: 16px;
  opacity: 100%;
  ${({ theme }) => theme.newBreakpoint('md')} {
    line-height: 24px;
    font-size: 20px;
    margin-bottom: 24px;
    margin-top: 8px;
    padding: 0;
  }
  a {
    margin-left: 8px;
    vertical-align: sub;
  }
`;

export const ButtonSeeAll = styled.button(
  ({ theme }) => css`
    width: 100%;
    height: 48px;
    border: solid 2px ${theme.colors.gbrand500};
    ${({ theme }) => theme.textTypes['Body-2-w400']};
    color: ${theme.colors.gbrand500};
    text-align: center;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    background-color: #ffffff;
    margin-top: 0px;
    ${theme.breakpoint('md')} {
      width: 99px;
    }
  `
);
